export default "__VITE_ASSET__DJXZ6IYG__"